import { render, staticRenderFns } from "./list-to-return-btn.vue?vue&type=template&id=1fc9fa41&"
import script from "./list-to-return-btn.vue?vue&type=script&lang=js&"
export * from "./list-to-return-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports